// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoArrRightOutlinedSvg from "@fishx/icons-svg/es/asn/PtoArrRightOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoArrRightOutlined = function PtoArrRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoArrRightOutlinedSvg
  }));
};

PtoArrRightOutlined.displayName = 'PtoArrRightOutlined';
export default React.forwardRef(PtoArrRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoArrRightOutlined.js
// module id = 3878
// module chunks = 0